import React from 'react';
import { motion } from 'framer-motion';
import { Star, BadgeCheck } from 'lucide-react';
const testimonials = [{
  name: 'María Laura',
  city: 'Buenos Aires',
  text: 'Por fin tengo todo organizado. Antes perdía horas en Pinterest buscando un patrón que estuviera completo o que se entendiera. Ahora entro a la carpeta, elijo la categoría y en 2 minutos ya estoy tejiendo. La variedad que hay es una locura, ¡vale cada centavo!',
  initials: 'ML',
  color: 'bg-rose-light text-rose-deep'
}, {
  name: 'Sofía',
  city: 'Córdoba',
  text: 'Empecé haciendo amigurumis para mis sobrinos y ahora estoy vendiendo tops para el verano gracias a esta biblioteca. La inspiración no se termina nunca y los PDFs son súper fáciles de seguir incluso si no sos experta. Es la mejor inversión que hice para mi emprendimiento.',
  initials: 'S',
  color: 'bg-gold-light/50 text-gold-dark'
}, {
  name: 'Carolina',
  city: 'Rosario',
  text: 'Compré otros cursos antes pero esto es distinto. No es un cursito más, es literalmente una biblioteca gigante que te queda para toda la vida. Ahorré muchísimo tiempo de búsqueda y ya le hice fundas nuevas a todos los almohadones del sillón con la sección de deco hogar.',
  initials: 'C',
  color: 'bg-green-100 text-green-700'
}, {
  name: 'Valentina',
  city: 'Mendoza',
  text: 'Me encanta que esté todo dividido por categorías y tan prolijo. Los bonos de regalo son espectaculares, la guía de macramé sola ya vale lo que pagué por todo el paquete. Si te gusta tejer, no lo dudes porque el valor que te llevás es inmenso.',
  initials: 'V',
  color: 'bg-blue-100 text-blue-700'
}];
export function Testimonials() {
  return <section className="py-14 px-6 bg-cream/30" data-id="element-196">
      <div className="max-w-6xl mx-auto" data-id="element-197">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-198">
          <h2 className="text-3xl md:text-4xl font-bold text-dark mb-2" data-id="element-199">
            LO QUE DICEN{' '}
            <span className="italic text-rose-deep font-normal" data-id="element-200">
              NUESTRAS TEJEDORAS
            </span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-201">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.1
        }} className="bg-white p-6 md:p-8 rounded-3xl shadow-soft border border-rose-light/20 flex flex-col h-full" data-id="element-202">
              <div className="flex items-center gap-1 mb-4 text-gold" data-id="element-203">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 md:w-5 md:h-5 fill-current" data-id="element-204" />)}
              </div>

              <p className="text-base md:text-lg text-dark/80 mb-6 italic leading-relaxed flex-grow" data-id="element-205">
                "{t.text}"
              </p>

              <div className="flex items-center gap-4 border-t border-cream pt-5 mt-auto" data-id="element-206">
                <div className={`w-12 h-12 rounded-full flex items-center justify-center font-bold text-lg ${t.color}`} data-id="element-207">
                  {t.initials}
                </div>
                <div data-id="element-208">
                  <h4 className="font-bold text-dark" data-id="element-209">{t.name}</h4>
                  <div className="flex items-center gap-2 text-xs md:text-sm text-dark/50" data-id="element-210">
                    <span data-id="element-211">{t.city}</span>
                    <span data-id="element-212">•</span>
                    <span className="flex items-center gap-1 text-green-600 font-medium" data-id="element-213">
                      <BadgeCheck className="w-3.5 h-3.5" data-id="element-214" /> Compra verificada
                    </span>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}